// Consumes the 1-hour reset token minted by ForgotPassword.tsx / the email link
// (`${console_base_url()}/auth/reset-password?token=...`, app/api/console_portal/auth.py). On
// success every existing session for the operator is force-signed-out server-side, so this lands
// on /login rather than trying to auto-sign-in.
import { type FormEvent, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";

import { ApiError, apiPost } from "../api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setErr(null);
    if (password !== confirm) {
      setErr("Passwords do not match.");
      return;
    }
    setBusy(true);
    try {
      await apiPost("/auth/reset-password", { token, new_password: password });
      setDone(true);
    } catch (e2) {
      setErr(e2 instanceof ApiError ? e2.message : "Could not reset the password.");
    } finally {
      setBusy(false);
    }
  };

  if (!token) {
    return (
      <div className="auth-screen">
        <div className="auth-card">
          <p className="err">This reset link is incomplete.</p>
          <p className="auth-hint"><Link to="/forgot-password">Request a new one</Link></p>
        </div>
      </div>
    );
  }

  if (done) {
    return (
      <div className="auth-screen">
        <div className="auth-card">
          <p className="cap-note">
            Password updated. Every existing session on this account was signed out.
          </p>
          <p className="auth-hint"><Link to="/login">Sign in</Link></p>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-screen">
      <form className="auth-card" onSubmit={submit}>
        <p className="auth-sub">Choose a new console password.</p>
        <label>
          New password
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="new-password"
            required
          />
        </label>
        <label>
          Confirm password
          <input
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            autoComplete="new-password"
            required
          />
        </label>
        <p className="auth-hint">
          At least 12 characters, with an uppercase letter, a lowercase letter, a number, and a symbol.
        </p>
        {err && <p className="err">{err}</p>}
        <button type="submit" className="primary" disabled={busy}>
          {busy ? "Updating…" : "Update password"}
        </button>
      </form>
    </div>
  );
}
